// extracted by mini-css-extract-plugin
module.exports = {"profile":"styles_profile__1oRVd","details":"styles_details__25XYz","avatar":"styles_avatar__olDeF","lottie":"styles_lottie__3ruIp","name":"styles_name__2L2VC"};